// removed by extract-text-webpack-plugin
module.exports = {"component":"ijvpj560R__DTqYnlSM2-","actionsPanel":"m30Ralg3e0xgvyDYYzkfe","contentPanel":"_1jMUV6675KG9ouHgsSZqV_","appointmentsContainer":"_19bRFwdbFPqNN2nzbHrX-S","isActive":"FMhFmrjqdi-J33B5RLxLS","hideForPrint":"TVISp5qHAH5_dAtUC5KL0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Appointments/LandingPage/LandingPage.css
// module id = 1465
// module chunks = 0